import { IGridItem } from '../../types/grid.types';

const items: IGridItem[] = [
	{
		x: 0,
		y: 0,
		width: 250,
		height: 250,
	},
	{
		x: -175,
		y: -250,
		width: 150,
		height: 200,
	},
	{
		x: 50,
		y: 300,
		width: 200,
		height: 200,
	},
	{
		x: -250,
		y: 200,
		width: 150,
		height: 200,
	},
	{
		x: 250,
		y: -300,
		width: 150,
		height: 100,
	},
	{
		x: 250,
		y: -50,
		width: 150,
		height: 100,
	},
	{
		x: 250,
		y: 250,
		width: 100,
		height: 100,
	},
	{
		x: 50,
		y: -200,
		width: 100,
		height: 100,
	},
];

export { items };
